<ion-item lines="none" class="ion-no-padding" [class.auto-pointer-evts]="lockIndicator == true"
  [style.min-width]="minWidth"
  [style.max-width]="maxWidth"
  [title]="lockIndicator == true ? lockTitle : ''">
  <ion-label *ngIf="!hideLabel" position="stacked">
    <ion-icon *ngIf="lockIndicator" slot="start" [name]="(disabled) ? 'lock-closed-outline' : 'lock-open-outline'"
      class="no-pointer-evts"></ion-icon>
    {{ label + (required ? '*' : '') }}
  </ion-label>
  <ion-select [id]="id" [disabled]="disabled" [multiple]="allowMultiple" [interface]="interface" [(ngModel)]="value"
    [placeholder]="placeholder" (ionBlur)="checkValidity()" (ionChange)="valueSelected()">
    <ion-select-option *ngFor="let opt of options" [value]="opt.value">{{ opt.displayValue }}</ion-select-option>
  </ion-select>
</ion-item>
<p *ngIf="subLabel != null" class="sub-label">
  {{ subLabel }}
</p>